export const MIN_ROW_HEIGHT = 36;
